(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping-policy"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.policy-tab');
  const contents = document.querySelectorAll('.policy-content');
  
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      // Tab-Wechsel-Logik
      const target = tab.getAttribute('data-tab');
      
      tabs.forEach(t => t.classList.remove('active-tab'));
      tab.classList.add('active-tab');
      
      contents.forEach(content => {
        content.style.display = 'none';
      });
      
      document.getElementById(target).style.display = 'block';
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
